export type HighlightSegment = {
	char: string
	matched: boolean
}

export const getFuzzyMatchIndices = (query: string, target: string): number[] => {
	if (!query) return []

	const indices: number[] = []
	const lowerQuery = query.toLowerCase()
	const lowerTarget = target.toLowerCase()

	let searchStartIndex = 0

	for (const char of lowerQuery) {
		const index = lowerTarget.indexOf(char, searchStartIndex)
		if (index === -1) return [] // No match

		indices.push(index)
		searchStartIndex = index + 1
	}

	return indices
}

export const getFuzzyHighlightSegments = (
	query: string,
	target: string,
): HighlightSegment[] => {
	const indices = new Set(getFuzzyMatchIndices(query, target))

	return target.split('').map((char, index) => ({
		char,
		matched: indices.has(index),
	}))
}